module.exports = __webpack_public_path__ + "img/bienvenido.1d5bda9d.png";